<template>
    <div>
        <el-row :gutter="20">
            <el-col :span="12">
                <el-input placeholder="请输入参数" v-model="ChanShu">
                    <template slot="prepend">参数</template>
                </el-input>
            </el-col>
            <el-col :span="12">
                <el-button type="primary" @click="shengChengXiaoChengXuMa">生成小程序码</el-button>
            </el-col>
        </el-row>
        <el-row>
            <el-result v-if="errcode" icon="error" :title="errcode" :subTitle="errmsg">

            </el-result>
            <el-result v-if="!errcode" icon="success" :title="errcode" :subTitle="errmsg">
                <template slot="extra">
                    {{ zifuchuan }}
                </template>
            </el-result>
            <el-image :src="src">
                <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                </div>
            </el-image></el-row>

    </div>
</template>

<script>


export default {
    data() {
        return {
            ChanShu: "",
            src: "",
            errcode: "",
            errmsg: "",
            zifuchuan: "",
        };
    },
    methods: {
        shengChengXiaoChengXuMa() {
            let that = this;
            const loading = that.$loading({
                lock: true,
                text: that.$t("lang.加载中"),
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            that.src = "";
            that.errcode = "";
            that.errmsg = "";
            that.axios.post("XiaoChengXu/ShengChengXiaoChengXuMa", {
                onlyText: that.ChanShu,
            }).then((response) => {
                loading.close();
                if (response.data.code == 101) {
                    that.src = response.data.data;
                    that.zifuchuan = response.data.msg;
                }
                else {
                    JSON.parse(response.data.data, (key, value) => {
                        if (key == "errcode") {
                            that.errcode = value;
                        }
                        if (key == "errmsg") {
                            that.errmsg = value;
                        }
                    });
                }
            });
        },
    },
};
</script>

<style></style>